import { render, staticRenderFns } from "./pushdetailsDialog.vue?vue&type=template&id=8c630102&scoped=true"
import script from "./pushdetailsDialog.vue?vue&type=script&lang=js"
export * from "./pushdetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./pushdetailsDialog.vue?vue&type=style&index=0&id=8c630102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c630102",
  null
  
)

export default component.exports